import styled from 'styled-components';

import InfoModal from '@components/ui/modals/InfoModal';
import Button from '@components/Button';
import { SimpleButton, Row } from '@components/formStyles';
import { GuestInfoWrapper } from '@components/ui/guest-box/guest-box-tab/GuestBox';

export const Wrapper = styled.div`
  width: 100%;

  border-radius: 8px;
  background-color: ${({ theme }) => theme.palette.white};
  position: relative;

  padding: 20px 0px 0px 0px;
  border: solid 1px ${({ theme }) => theme.palette.grey300};
  @media (min-width: 600px) {
    padding: 40px 20px 20px 26px;
    height: auto;
  }
`;
export const WarningBoxWrapper = styled.div`
  max-width: 45%;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    margin: 20px auto;
    max-width: 95%;
  }
`;

export const PackageInfoWrapper = styled.div`
  display: flex;
  border-radius: 8px;
  margin-top: 32px;
  margin-bottom: 12px;
  align-items: center;
  justify-content: center;
  border: none;
  @media ${({ theme }) => `(min-width: ${theme.breakPoint.LARGE_1X})`} {
    width: 100%;
    border: 1px solid #dde1e8;
    padding: 16px;
  }
`;

export const Text = styled.span<{
  bold?: boolean;
  size?: number;
  opacity?: number;
}>`
  font-size: ${({ size }) => size || 20}px;
  font-weight: ${({ bold }) => (bold ? 'bold' : 'normal')};
  color: ${({ theme }) => theme.palette.darkGrey};
  opacity: ${({ opacity }) => opacity};
  white-space: nowrap;
`;

export const HorizontalBorder = styled.div`
  height: 1px;
  width: 100%;
  margin: 0px 0px 12px 6px !important;
  background-color: ${({ theme }) => theme.palette.grey300};

  @media ${({ theme }) => `(min-width: ${theme.breakPoint.LARGE_1X})`} {
    margin: 0px 0px 20px 20px;
  }
`;
export const MobileHorizontalBorder = styled.div<{ width?: number }>`
  height: 1px;
  width: ${({ width }) => width || 100}%;
  margin-left: 0px;
  background-color: ${({ theme }) => theme.palette.grey300};
`;

export const TourSelectionCardInfoTitle = styled.span`
  font-weight: 700;
  line-height: 24px;
  font-size: 14px;
  color: ${({ theme }) => theme.palette.grey1100};
`;

export const TourSelectionCardInfoText = styled.span`
  font-weight: 500;
  line-height: 24px;
  font-size: 16px;
  color: ${({ theme }) => theme.palette.grey1100};
`;

export const Title = styled.span<{ bold?: boolean }>`
  font-size: 20px;
  font-weight: ${({ bold }) => (bold ? 'bold' : 'normal')};
  color: ${({ theme }) => theme.palette.darkGrey};
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    font-size: 16px;
  }
`;

export const RoomDetailsContainer = styled.div`
  margin: 20px 16px 0px 0px;
  position: relative;
  height: 100%;
  border-top: none;
  width: 100%;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    width: 100%;
  }
`;

export const TourDateItemInfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: flex-start;
  padding: 12px;
  @media ${({ theme }) => `(min-width: ${theme.breakPoint.LARGE_1X})`} {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }
`;

export const TourDateItemCol = styled.div`
  display: flex;
  flex-direction: column;
  @media ${({ theme }) => `(min-width: ${theme.breakPoint.LARGE_1X})`} {
    width: 50%;
  }
`;

export const RoomDetailsButton = styled.button`
  background-color: ${({ theme }) => theme.palette.gray87};
  border: none;
  width: 35px;
  height: 35px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  svg {
    fill: ${({ theme }) => theme.palette.primaryBrand};
    transform: scale(1.8);
  }
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    display: none;
  }
`;

export const PrevButton = styled(RoomDetailsButton)`
  left: -32px;
`;
export const NextButton = styled(RoomDetailsButton)`
  right: -32px;
`;

export const BoxHeaderWrapper = styled.div`
  display: flex;
  width: 100%;
  padding: 12px;
  flex-direction: column;
  @media ${({ theme }) => `(min-width: ${theme.breakPoint.LARGE_1X})`} {
    padding: 0px;
  }
`;
export const BoxHeaderTitle = styled.span`
  font-size: 18px;
  line-height: 28px;
  font-weight: 700;
  color: ${({ theme }) => theme.palette.grey1100};
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    font-size: 24px;
    font-weight: 700;
    line-height: 32px;
  }
`;

export const BoxHeaderInfo = styled.span`
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: ${({ theme }) => theme.palette.grey1100};
`;

export const BoxWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  overflow-x: auto;
  scroll-behavior: smooth;
  margin-top: 24px;
  border-top: 1px solid ${({ theme }) => theme.palette.grey300};
  border-bottom: 1px solid ${({ theme }) => theme.palette.grey300};
  @media ${({ theme }) => `(min-width: ${theme.breakPoint.LARGE_1X})`} {
    display: flex;
    flex-direction: row;
    border-radius: 8px;
    width: 100%;
    border: 1px solid ${({ theme }) => theme.palette.grey300};
  }
`;
export const Box = styled.div`
  padding: 20px 12px;
  border-radius: 2px;
  background-color: ${({ theme }) => theme.palette.white};
  min-width: 175px;
  display: flex;
  flex-direction: column;
  border: 1px solid ${({ theme }) => theme.palette.grey300};
  @media ${({ theme }) => `(min-width: ${theme.breakPoint.LARGE_1X})`} {
    width: 100%;
    height: auto;
    display: block;
    border-radius: 0;
    border: none;
    margin-right: 24px;
  }
`;

export const InfoBorder = styled.div`
  height: 48px;
  width: 1px;
  margin: 0px 16px 0px 16px;
  background-color: ${({ theme }) => theme.palette.grey300};
`;

export const ResponsiveBox = styled.div`
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }
`;

export const Actions = styled.div`
  position: absolute;
  right: 20px;
  display: flex;
  flex-direction: column;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    position: static;
    right: 0;
    display: block;
    width: 100%;
  }
`;

export const DateDetailButton = styled(SimpleButton)`
  color: ${({ theme }) => theme.palette.primaryBrand};
  font-size: 14px;
  font-weight: bold;
  margin-left: 30px;
  margin-top: 20px;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    margin-left: calc(50% - 80px);
  }
`;

export const Count = styled(Text)`
  font-size: 14px;
  font-weight: bold;
  color: ${({ theme }) => theme.palette.primaryBrand};
  position: absolute;
  right: 43px;
`;

export const DynamicRow = styled(Row)`
  align-items: center;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const DetailsButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  min-width: 140px;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.DESKTOP})`} {
    background-color: black;
    width: 100%;
    border-radius: 4px;
    height: 32px;
  }
`;

export const TextButton = styled(Button).attrs({
  type: 'link',
  size: 'small',
})`
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 0px !important;

  & > :last-child {
    height: 16px;
    transition: transform 0.3s ease-in-out;
  }
`;

export const MobileTextButton = styled(Button).attrs({
  type: 'link',
  size: 'small',
})`
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 0px !important;
`;

export const MobileSelectDateButton = styled.span`
  color: white;
`;

export const SelectDateButton = styled(Button)`
  width: 100%;
  font-size: 14px !important;
  height: 40px !important;
  line-height: 24px;
  font-weight: 400 !important;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    width: 100%;
    height: 40px;
    font-size: 14px;
  }
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.PHONE})`} {
    width: 100%;
    height: 20px;
    font-size: 14px;
  }
`;

export const Line = styled.div`
  border-top: solid 1px ${({ theme }) => theme.palette.lightBlueGrey};
  margin: 23px 0 20px;
`;

export const FlexEnd = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const GuestBoxWrapper = styled.div`
  width: 100%;
  margin-top: -25px;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    width: 100%;
    box-shadow: 0 10px 40px 0 rgba(58, 58, 58, 0.2);
    ${GuestInfoWrapper} {
      padding: 0 10px;
    }
  }
`;

export const BottomButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  width: 95% !important;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.DESKTOP})`} {
    background-color: black;
    width: 120px;
    border-radius: 4px;
    height: 32px;
  }
`;
export const DatesInfoBorder = styled.div`
  height: 88px;
  width: 1px;
  margin: -6px 30px 0px 0px;
  background-color: ${({ theme }) => theme.palette.grey300};
`;

export const RoomInfoBorder = styled.div`
  height: 88px;
  width: 1px;
  margin: 22px 12px 0px 12px;
  background-color: ${({ theme }) => theme.palette.grey300};
`;
export const VariationBoxWrapper = styled.div`
  width: 50%;
  margin-top: -10px;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    width: 100%;
    margin-top: 10px;
  }
`;

export const TourCardDatesPoints = styled.div`
  margin-top: 12px;
  @media ${({ theme }) => `(min-width: ${theme.breakPoint.LARGE_1X})`} {
    margin-top: 0px;
  }
`;

export const TourPointsDate = styled.span`
  font-size: 16px;
  font-weight: bold;
  color: ${({ theme }) => theme.palette.darkGrey};
  display: inline-block;
  margin-right: 10px;
  padding-bottom: 10px;
`;

export const NotAvailabilityText = styled.span`
  font-size: 16px;
  font-weight: bold;
  color: ${({ theme }) => theme.palette.coral};
  display: inline-block;
  margin-right: 30px;
`;

export const TourPointsText = styled.span`
  font-size: 16px;
  font-weight: 700;
  color: ${({ theme }) => theme.palette.darkGrey};
`;

export const StyledInfoModal = styled(InfoModal)`
  max-width: 600px;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.DESKTOP})`} {
    width: 100vw !important;
    position: fixed;
    top: 0;
    left: 0;
  }
`;

export const DiscountedPackagePriceWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
`;

export const StyledButton = styled(Button)<{ selected: boolean }>`
  width: 170px;
  height: 50px !important;
  font-weight: bold;
  font-size: 16px;
  margin-left: 20px;
  margin-right: 10px;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    display: flex;
    font-size: 14px;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 45px;
    margin-left: -5px;
    margin-top: 60px;
  }
  @media (max-width: 600px) {
    margin-top: 30px;
    margin-bottom: 40px;
  }
  ${({ selected, theme }) =>
    selected &&
    `border-color: ${theme.palette.greenSuccess} !important;
    color: ${theme.palette.greenSuccess} !important;
    background-color: ${theme.palette.white} !important;
    pointer-events: none !important; `}
`;
